<div class="modal">
  <a class="close" (click)="close()">Cerrar</a>
  <h1>{{ isEdit ? "Edición" : "Nueva condición" }}</h1>
  <div class="condiciones">
    <form [formGroup]="form">
      <div class="wrapperG3">
        <div class="controlWrapper">
          <label>Plazo<span class="required">*</span></label>
          <div class="inputAndUnit">
            <input type="number" formControlName="term" />
            <span>Meses</span>
          </div>
          <span
            *ngIf="
              form.get('term')?.hasError('required') &&
              form.get('term')?.touched
            "
            class="error"
            >El plazo es requerido.</span
          >
          @if(hasTermLimitError()) {
            <span class="error">El plazo debe estar entre {{ minTerm }} y {{ maxTerm }} meses.</span>
          }
        </div>
        <div class="controlWrapper">
          <label>Enganche mínimo<span class="required">*</span></label>
          <div class="inputAndUnit">
            <input type="number" formControlName="minDownPaymentPercentage" />
            <span>%</span>
          </div>
          <span
            *ngIf="
              form.get('minDownPaymentPercentage')?.hasError('pattern') &&
              form.get('minDownPaymentPercentage')?.touched
            "
            class="error"
            >Ingrese un porcentaje válido (0-99.99).</span
          >
        </div>
        <div class="controlWrapper">
          <label>Enganche máximo<span class="required">*</span></label>
          <div class="inputAndUnit">
            <input type="number" formControlName="maxDownPaymentPercentage" />
            <span>%</span>
          </div>
          <span
            *ngIf="
              form.get('maxDownPaymentPercentage')?.hasError('pattern') &&
              form.get('maxDownPaymentPercentage')?.touched
            "
            class="error"
            >Ingrese un porcentaje válido (0-99.99).</span>
          <span
            *ngIf="
              form.hasError('maxLessThanMin') && !form.get('maxDownPaymentPercentage')?.hasError('pattern') &&
              form.get('maxDownPaymentPercentage')?.touched
            "
            class="error"
            >El porcentaje máximo de enganche no puede ser menor que el porcentaje mínimo.</span>
        </div>
        <div class="controlWrapper">
          <label>Interés nominal<span class="required">*</span></label>
          <div class="inputAndUnit">
            <input type="number" formControlName="nominalRate" />
            <span>%</span>
          </div>
          <span
            *ngIf="
              form.get('nominalRate')?.hasError('pattern') &&
              form.get('nominalRate')?.touched
            "
            class="error"
            >Ingrese un porcentaje válido (0-99.99).</span
          >
        </div>
        <div class="controlWrapper">
          <label>Comisión por apertura<span class="required">*</span></label>
          <div class="inputAndUnit">
            <input type="number" formControlName="openingFeePercentage" />
            <span>%</span>
          </div>
          <span
            *ngIf="
              form.get('openingFeePercentage')?.hasError('pattern') &&
              form.get('openingFeePercentage')?.touched
            "
            class="error"
            >Ingrese un porcentaje válido (0-99.99).</span
          >
        </div>
        <div class="controlWrapper">
          <label>Opción de compra<span class="required">*</span></label>
          <div class="inputAndUnit">
            <input type="number" formControlName="purchasePercentage" />
            <span>%</span>
          </div>
          <span
            *ngIf="
              form.get('purchasePercentage')?.hasError('pattern') &&
              form.get('purchasePercentage')?.touched
            "
            class="error"
            >Ingrese un porcentaje válido (0-99.99).</span
          >
        </div>
        <div class="controlWrapper">
          <label>Depósito en garantía<span class="required">*</span></label>
          <div class="inputAndUnit">
            <input type="number" formControlName="warrantyDepositPercentage" />
          </div>
          <span
            *ngIf="
              form.get('warrantyDepositPercentage')?.hasError('required') &&
              form.get('warrantyDepositPercentage')?.touched
            "
            class="error"
            >El depósito en garantía es requerido.</span
          >
          <span
            *ngIf="
              form.hasError('warrantyDepositOutOfRange') && !form.get('warrantyDepositPercentage')?.hasError('required') &&
              (form.get('warrantyDepositPercentage')?.touched || form.get('term')?.touched)
            "
            class="error"
            >El depósito debe estar entre 0 y {{ (form.get('term')?.value || 1) - 1 }}.</span
          >
        </div>
        <div class="controlWrapper">
          <label>Períodos de gracia<span class="required">*</span></label>
          <div class="inputAndUnit">
            <input
              type="number"
              formControlName="gracePeriod"
              min="0"
              step="1"
              inputmode="numeric"
              (keydown)="preventNonInteger($event)"
            />
            <span>Meses</span>
          </div>
          <span
            *ngIf="
              form.get('gracePeriod')?.hasError('required') &&
              form.get('gracePeriod')?.touched
            "
            class="error"
            >El período de gracia es requerido.</span
          >
          <span
            *ngIf="
              form.hasError('gracePeriodTooHigh') && !form.get('gracePeriod')?.hasError('pattern') && !form.get('gracePeriod')?.hasError('required') &&
              (form.get('gracePeriod')?.touched || form.get('term')?.touched)
            "
            class="error"
            >El período de gracia debe ser menor al plazo.</span
          >
          <span
            *ngIf="
              form.get('gracePeriod')?.hasError('pattern') && !form.get('gracePeriod')?.hasError('required') &&
              form.get('gracePeriod')?.touched
            "
            class="error"
            >El período de gracia debe ser un número valido.</span
          >
          <span
            *ngIf="hasGracePeriodPreferencesError()"
            class="error"
            >Debe completar las preferencias antes de poder ingresar períodos de gracia.</span
          >
        </div>
      </div>

      <!-- Acciones para modal condición -->
      <div class="actions">
        <div class="wrapper">
          <button type="button" class="secondary" (click)="close()">
            Cancelar
          </button>
          <button
            type="submit"
            class="primary"
            [disabled]="hasRealValidationErrors() || isTermError"
            (click)="saved()"
          >
            Aceptar
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
